@if (guestCreator) {
  <h2>Accounts Sponsored by: {{guestCreator?.firstName}} {{guestCreator?.lastName}}</h2>
}

<app-guest-table [guests]="guests"></app-guest-table>
